const SEARCH_TYPE_PRODUCT = 'product';
const SEARCH_PRE_PAGE = 9;
document.addEventListener('DOMContentLoaded', function () {
  const boot = window.__RO_SEARCH_PRODUCTS_BOOTSTRAP__;
  if (!boot || !Array.isArray(boot.searchResults)) return;
  const accessories_value = boot.accessories_value;
  const searchFiltersLabelMap = {
    all: boot.all_result_label,
    [accessories_value]: boot.accessories_label,
    others: boot.others_label,
  };

  const searchResults = boot.searchResults;
  const collectionList = new Set(boot.collectionHandles || []);

  let filterCollectionsResults = searchResults;

  const filterHandles = collectionList;
  if (filterHandles && filterHandles.size > 0 && searchResults.length > 0) {
    filterCollectionsResults = searchResults.filter((item) => {
      return item.collections_handle.some((h) => filterHandles.has(String(h)));
    });
  }

  const filtersResultData = initFiltesrMap(filterCollectionsResults);

  const searchParams = new URLSearchParams(window.location.search);
  const currentType = searchParams.get('currentType') || 'all';
  const currentList = filtersResultData[currentType] || [];
  const searchCurrentPage = searchParams.get('currentPage') || 1;
  const total = currentList.length || 0;
  const totalPages = Math.max(Math.ceil(total / SEARCH_PRE_PAGE), 1);
  const currentPage = Math.min(searchCurrentPage, totalPages);

  initSearchInputEvent(searchParams);

  renderNoData(filtersResultData, currentList);

  if (filtersResultData.all.length === 0) return;

  setResultCount(total);

  renderFilterMap(filtersResultData, currentType);
  setFilterEvent();

  if (currentList.length === 0) return;

  renderProducts(currentList, currentPage);

  renderPaginationor(currentPage, totalPages);
  setPaginationorEvent(currentPage, totalPages);

  function setResultCount(total) {
    const resultsCount = document.getElementById('ResultsCount');
    resultsCount.innerHTML = total;
  }

  function initFiltesrMap(resultsList) {
    const searchFiltersValueMap = {
      all: [],
      [accessories_value]: [],
      others: [],
    };
    resultsList.forEach((item) => {
      searchFiltersValueMap.all.push(item);
      if (item.product_type == accessories_value) {
        searchFiltersValueMap[accessories_value].push(item);
      } else {
        searchFiltersValueMap.others.push(item);
      }
    });
    return searchFiltersValueMap;
  }

  function renderFilterMap(filtersResultData, currentType) {
    if (filtersResultData.all.length === 0) return;
    const templateEl = document.getElementById('search-filters-template');
    const container = document.querySelector('[data-search-filters-container]');
    if (!templateEl || !container) return;

    const templateHTML = templateEl.innerHTML.trim();
    const allCount = filtersResultData.all.length ?? 0;
    const accessoriesCount = filtersResultData[accessories_value].length ?? 0;
    const othersCount = filtersResultData.others.length ?? 0;

    const html = templateHTML
      .replaceAll('[[select_option_label]]', searchFiltersLabelMap[currentType])
      .replaceAll('[[select_option_count]]', filtersResultData[currentType].length ?? 0)
      .replaceAll('[[all_result_count]]', allCount)
      .replaceAll('[[all_result_checked]]', currentType === 'all' ? 'checked' : '')
      .replaceAll('[[accessories_count]]', accessoriesCount)
      .replaceAll('[[accessories_active_checked]]', currentType === accessories_value ? 'checked' : '')
      .replaceAll('[[accessories_count_disabled]]', accessoriesCount == 0 ? 'disabled' : '')
      .replaceAll('[[others_count]]', othersCount)
      .replaceAll('[[others_active_checked]]', currentType === 'others' ? 'checked' : '')
      .replaceAll('[[others_count_disabled]]', othersCount == 0 ? 'disabled' : '');
    container.innerHTML = html;
  }

  function setFilterEvent() {
    const productTypeContainer = document.getElementById('ProductTypeFilter');
    if (productTypeContainer) {
      const radios = productTypeContainer.querySelectorAll('input[name="product-type-group"]');
      if (radios.length > 0) {
        radios.forEach(function (radio) {
          radio.addEventListener('change', onChange);
        });
      }
      const selector = productTypeContainer.querySelector('.ro-search-filters-label');
      const filterOptions = productTypeContainer.querySelector('#SearchFiltersOptions');
      selector.addEventListener('click', function () {
        if (filterOptions.classList.contains('visibility')) {
          filterOptions.classList.remove('visibility');
        } else {
          filterOptions.classList.add('visibility');
        }
      });
      const selectOptionList = productTypeContainer.querySelectorAll('.ro-search-filters-option');
      if (selectOptionList.length > 0) {
        selectOptionList.forEach(function (select) {
          select.addEventListener('click', onChange);
        });
      }
      function onChange(event) {
        const value = event.target.value || event.target.dataset.value;

        var url = new URL(window.location.href);
        var params = url.searchParams;

        params.delete('currentType');
        params.delete('currentPage');
        if (value !== 'all') {
          params.set('currentType', value);
        }
        reloadUrl(url, params);
      }
    }
  }

  /** 写入 HTML 属性时转义，避免 KSP 等字段破坏 DOM */
  function escapeHtmlAttr(value) {
    if (value == null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;');
  }

  /** 标签文案插入 DOM 时做基本转义 */
  function escapeHtmlText(value) {
    if (value == null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /**
   * 与 blocks/_collection-product-card 一致：disableselling 1/2 时仅展示预售类标签
   */
  function buildPresaleTagHtml(disableselling, i18n) {
    if (disableselling === '1') {
      return `<span class="ro-product-tag gray">${escapeHtmlText(i18n.tag_remind)}</span>`;
    }
    if (disableselling === '2') {
      return `<span class="ro-product-tag red">${escapeHtmlText(i18n.pre_order)}</span>`;
    }
    return '';
  }

  function renderProducts(currentList, currentPage) {
    const templateEl = document.getElementById('product-card-template');
    const container = document.querySelector('[data-search-product-card-container]');
    if (!templateEl || !container) return;

    const templateHTML = templateEl.innerHTML.trim();
    const cardI18n = boot.productCardI18n || { tag_remind: '', pre_order: '' };

    const start = (Math.max(currentPage, 1) - 1) * SEARCH_PRE_PAGE;
    const pageItems = currentList.slice(start, start + SEARCH_PRE_PAGE);

    const html = pageItems
      .map(function (item) {
        const ds = String(item.disableselling != null ? item.disableselling : '').trim();
        const isPresale = ds === '1' || ds === '2';

        let tagList = '';
        if (!isPresale && item.custom_metafields?.tag && item.custom_metafields.tag.length > 0) {
          item.custom_metafields.tag.forEach((tag) => {
            tagList += getTagHTML(tag);
          });
        }

        const showDiscountClass = !isPresale && item.show_discount_amount ? 'visible' : '';
        const showSoldOutClass = !isPresale && !item.available ? 'visible' : '';

        let showAddButtonClass;
        let showLearnMoreClass;
        if (isPresale) {
          showAddButtonClass = 'visible';
          showLearnMoreClass = '';
        } else if (item.available) {
          showAddButtonClass = 'visible';
          showLearnMoreClass = '';
        } else {
          showAddButtonClass = '';
          showLearnMoreClass = 'visible';
        }

        const questionDisplay = ds === '1' ? 'block' : 'none';
        const originalPriceDisplay = ds === '1' ? 'none' : 'flex';

        let buyDisplay = 'none';
        let notifyDisplay = 'none';
        let preOrderDisplay = 'none';
        let learnMorePrimaryDisplay = 'none';

        if (ds === '1') {
          notifyDisplay = 'inline-flex';
          learnMorePrimaryDisplay = 'inline-flex';
        } else if (ds === '2') {
          preOrderDisplay = 'inline-flex';
          learnMorePrimaryDisplay = 'inline-flex';
        } else if (item.available) {
          buyDisplay = 'inline-flex';
        }

        const showCompareAt = !isPresale && item.show_discount_amount;

        return templateHTML
          .replace('[[presale_tag]]', buildPresaleTagHtml(ds, cardI18n))
          .replace('[[tagList]]', tagList)
          .replace('[[discount_amount]]', item.discount_amount)
          .replace('[[show_discount_amount]]', showDiscountClass)
          .replaceAll('[[current_variant_id]]', item.current_variant_id)
          .replaceAll('[[product_image]]', item.product_image)
          .replaceAll('[[product_title]]', item.product_title)
          .replaceAll('[[product_price]]', item.product_price)
          .replaceAll('[[product_url]]', item.product_url)
          .replaceAll('[[product_compare_at_price]]', showCompareAt ? item.product_compare_at_price : '')
          .replace('[[show_sold_out_tag]]', showSoldOutClass)
          .replace('[[question_display]]', questionDisplay)
          .replace('[[original_price_display]]', originalPriceDisplay)
          .replaceAll('[[buy_display]]', buyDisplay)
          .replace('[[notify_display]]', notifyDisplay)
          .replace('[[pre_order_display]]', preOrderDisplay)
          .replace('[[learn_more_primary_display]]', learnMorePrimaryDisplay)
          .replace('[[ksp]]', escapeHtmlAttr(item.ksp))
          .replace('[[show_add_button]]', showAddButtonClass)
          .replace('[[show_learn_more]]', showLearnMoreClass)
          .replace('[[product_id]]', item.product_id)
          .replace('[[judgeme_badge]]', item.judgeme?.badge ?? '');
      })
      .join('');
    container.innerHTML = html;

    document.dispatchEvent(
      new CustomEvent('ro-search:products-rendered', {
        detail: {
          pageItems: pageItems,
          container: container,
          currentType: currentType,
        },
      })
    );
  }

  function renderNoData(filtersResultData, currentList) {
    if (filtersResultData.all.length === 0) {
      const SearchResultBlock = document.getElementById('SearchResultBlock');
      SearchResultBlock.classList.add('no-data');
    } else if (currentList.length === 0) {
      const SearchResultContainer = document.getElementById('SearchResultContainer');
      SearchResultContainer.classList.add('no-data');
    }
  }

  function getTagHTML(tagName) {
    return `<span class="ro-product-tag red visible">${tagName}</span>`;
  }

  function renderPaginationor(currentPage = 1, totalPages) {
    if (totalPages < 1) return;
    const templateEl = document.getElementById('search-paginationor-template');
    const container = document.querySelector('[data-search-paginationor-container]');
    if (!templateEl || !container) return;

    const templateHTML = templateEl.innerHTML.trim();
    const html = templateHTML
      .replace('[[prev_disabled]]', currentPage <= 1 ? 'disabled' : '')
      .replace('[[next_disabled]]', currentPage >= totalPages ? 'disabled' : '')
      .replaceAll('[[currentPage]]', currentPage)
      .replaceAll('[[totalPages]]', totalPages);
    container.innerHTML = html;
  }

  function setPaginationorEvent(currentPage, totalPages) {
    const paginationor = document.querySelector('[data-search-paginationor-container]');
    paginationor.addEventListener('click', handlePaginationBtn);
    const stepInput = paginationor.querySelector('#PaginationStep');
    if (stepInput) {
      stepInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitPageInput(e);
        }
      });
      stepInput.addEventListener('blur', submitPageInput);
    }
    function handlePaginationBtn(event) {
      const type = event.target.dataset.type || '';
      if (!type || event.target.disabled) return;
      let newPage = 1;
      if (type === 'next') {
        newPage = Math.min(currentPage + 1, totalPages);
      } else if (type === 'prev') {
        newPage = Math.max(currentPage - 1, 1);
      }

      if (newPage === currentPage) return;

      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.delete('currentPage');
      if (newPage > 1) params.set('currentPage', newPage);
      reloadUrl(url, params);
    }
    function submitPageInput(event) {
      const value = event.target.value;
      let newValue = value;
      if (value < 1) newValue = 1;
      if (value > totalPages) newValue = totalPages;
      if (value === currentPage) return;

      stepInput.value = newValue;
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.delete('currentPage');

      if (newValue > 1) params.set('currentPage', newValue);

      reloadUrl(url, params);
    }
  }

  function initSearchInputEvent(searchParams) {
    const inputId = 'search-result-input-' + boot.sectionId;
    const searchInput = document.getElementById(inputId);
    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        const term = searchInput.value.trim();
        if (searchParams.get('q') === term) return;

        const url = new URL(window.location.href);
        const params = url.searchParams;

        params.delete('currentType');
        params.delete('currentPage');
        params.set('q', term);

        reloadUrl(url, params);
      }
    });
  }

  function reloadUrl(url, params) {
    params.set('type', SEARCH_TYPE_PRODUCT);
    url.search = params.toString();
    window.location.href = url.toString();
  }
});
